import Toggle from 'react-toggle'
import { withHelpersModifiers  } from 'bloomer';
import 'react-toggle/style.css'

export default withHelpersModifiers(Toggle)


// WEBPACK FOOTER //
// ./src/components/Toggle.js